import { render, staticRenderFns } from "./page-back.vue?vue&type=template&id=73660ec5&scoped=true"
import script from "./page-back.vue?vue&type=script&lang=ts"
export * from "./page-back.vue?vue&type=script&lang=ts"
import style0 from "./page-back.vue?vue&type=style&index=0&id=73660ec5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73660ec5",
  null
  
)

export default component.exports